(function($){

	//click listener to display sub-menus if there are any
	var mobile_top_level_nav = $('.nav .js-nav-item.has_subpages > a');
	mobile_top_level_nav.on('click', function(event) {
		event.preventDefault();
		$(this).closest('.js-nav-item').toggleClass('clicked_menu');
	});

	$('.nav_hamburger').on('click', function(event) {
		event.preventDefault();
		$(this).siblings('.nav').toggleClass('active');
	});
})(jQuery);